import { TaskType, UpdateTask } from '@griply/types';

export const normalizeUpdateTasks = (tasks: UpdateTask[]): UpdateTask[] =>
  tasks.map((task) => {
    const normalized = { ...task };

    if ('endStrategy' in task) {
      normalized.endStrategy = task.endStrategy
        ? {
            deadline:
              task.endStrategy.deadline && !task.schedules?.length
                ? task.endStrategy.deadline
                : null,
            completionCount: task.endStrategy.completionCount ?? null,
          }
        : null;
    }

    if ('reminderTime' in task) {
      normalized.reminderTime = task.reminderTime ?? null;
    }

    if ('reminders' in task) {
      normalized.reminders = task.reminders ?? null;
      // Reminders are authoritative when present (incl. `[]`), so the legacy value can't resurface.
      if (normalized.reminders != null) {
        normalized.reminderTime = null;
      }
    }

    if ('hideOnTodo' in task) {
      normalized.hideOnTodo =
        task.type === TaskType.Habit ? task.hideOnTodo : null;
    }

    return normalized;
  });
